<template lang='pug' src='./nav-desktop.pug'></template>

<script>
import Icon from 'components/icon/icon'

import { openModal, openVideo } from '@/methods'

export default {
  data () {
    return {
      styleWidth: '',
      styleHeight: '',
      styleTop: '',
      styleLeft: '',
      dropdownActive: false,
      active: 1
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    },
    props () {
      return this.$store.state.app.global
    },
    dropdownBackgroundStyleObject () {
      return {
        height: this.styleHeight,
        width: this.styleWidth,
        top: this.styleTop,
        left: this.styleLeft
      }
    }
  },
  mixins: [openModal, openVideo],
  components: {
    Icon
  },
  methods: {
    handleEnter (e, i) {
      this.dropdownActive = true
      this.active = i

      const navCoords = e.target.parentElement.getBoundingClientRect()

      setTimeout(() => {
        const coords = e.target.children[0].getBoundingClientRect()
        this.styleWidth = coords.width + 'px'
        this.styleHeight = coords.height + 'px'
        this.styleTop = coords.top - navCoords.top + 'px'
        this.styleLeft = coords.left - navCoords.left + 'px'
      }, 100)
    },
    handleLeave () {
      this.dropdownActive = false
      this.active = false
      // this.styleWidth = ''
      // this.styleHeight = ''
      // this.styleTop = ''
      // this.styleLeft = ''
    },
    handleRoute (e) {
      this.$router.push(e.path)
      this.handleLeave()
    },
    goToConsultation () {
      this.$router.push('/free-orthodontic-consultation')
      // this.handleLeave()
    },
    goToPediatric () {
      this.$router.push('/pediatric-appointment')
      // this.handleLeave()
    },
    goToPage (path) {
      this.$router.push(path.children[0].path)
    },

    //  Goes to external links
    goToAdultExam () {
      window.open(
        'https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=izsscu',
        '_blank'
      )
    },
    goToChildExam () {
      window.open(
        'https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=dylndc',
        '_blank'
      )
    }

  }
}
</script>



// WEBPACK FOOTER //
// nav-desktop.vue?dbfa2808